import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=60f8fdbd&scoped=true&"
import script from "./ContactUs.js?vue&type=script&lang=js&"
export * from "./ContactUs.js?vue&type=script&lang=js&"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=60f8fdbd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8fdbd",
  null
  
)

export default component.exports